var _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivities256A49B0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 136,
    viewBox: "0 0 263 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 263,
    height: 137
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 137,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.1001 18.8672C116.775 36.5489 157.144 5.24881 180.19 14.8881C203.237 24.5274 179.784 42.3975 194.333 56.5797C208.882 70.762 239.902 59.2979 239.902 95.027C239.902 111.264 220.273 115.94 202.713 121.005C185.153 126.07 163.605 127.306 139.859 127.291C100.404 127.264 84.4722 114.002 57.625 127.291C26.5545 123.756 55.6412 100.071 31.9595 75.9597C8.27782 51.8482 41.4251 1.18549 79.1001 18.8672Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.284 109.693C227.351 109.693 236.488 128.026 199.57 128.026C162.653 128.026 196.287 152.692 129.383 147.406C73.7869 136.833 91.4123 135.095 61.5323 132.593C-1.60258 127.307 34.9716 109.693 64.9578 109.693C178.245 109.693 147.089 109.693 204.284 109.693Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124,
    cy: 119.618,
    rx: 48,
    ry: 3.5,
    fill: "#ECEDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 46.6369C51 46.6369 72.1417 31.2367 71.3207 22C70.9102 22.821 84.4573 40.6585 85.2784 45.2871C85.4836 45.1943 79.3258 67.6066 62.084 72C62.084 71.4676 57.1578 55.2627 51 46.6369Z",
    fill: "#E3E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9355 45.6861L62.7388 44.8889C62.7832 44.8774 67.2734 43.6336 73.437 33.8911L74.1307 34.33C67.7525 44.4119 63.1292 45.6385 62.9355 45.6861Z",
    fill: "#D0D2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7313 53.0977L68.5076 52.3083L68.6197 52.7028L68.5056 52.3083C68.5499 52.2955 72.9921 50.8903 78.8006 40.9324L79.5099 41.3458C73.4995 51.6502 68.9231 53.046 68.7313 53.0977Z",
    fill: "#D0D2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8648 50.3229C59.6942 50.3229 60.3665 49.6506 60.3665 48.8213C60.3665 47.9919 59.6942 47.3196 58.8648 47.3196C58.0355 47.3196 57.3631 47.9919 57.3631 48.8213C57.3631 49.6506 58.0355 50.3229 58.8648 50.3229Z",
    fill: "#D0D2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8382 57.9919C63.7081 57.9919 64.4133 57.2867 64.4133 56.4167C64.4133 55.5468 63.7081 54.8416 62.8382 54.8416C61.9682 54.8416 61.263 55.5468 61.263 56.4167C61.263 57.2867 61.9682 57.9919 62.8382 57.9919Z",
    fill: "#D0D2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.704 53.4193C133.845 52.133 134.83 51.01 136.078 50.7151L155.583 46.1046C157.062 45.755 158.399 46.6765 158.569 48.1593L163.529 91.6372C163.697 93.123 162.636 94.6088 161.155 94.9589L99.2572 109.59C97.7782 109.94 96.4413 109.018 96.2709 107.535L92.1045 71.0145C91.936 69.5287 92.9972 68.043 94.4787 67.6928L128.16 59.7313C131.077 59.0443 133.375 56.4248 133.704 53.4193Z",
    fill: "#424B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5546 107.94L162.222 92.6539L155.621 48.27L90.9533 63.5559L97.5546 107.94Z",
    fill: "#ECEDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5546 107.94L162.222 92.6539L154.602 48.5107L90.9533 63.5559L97.5546 107.94Z",
    fill: "#D0D2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5545 107.94L162.222 92.6539L151.707 46.45L87.0395 61.7359L97.5545 107.94Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.555 107.939L162.223 92.6536L150.201 47.7269L85.9499 62.9143L97.555 107.939Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5551 107.94L162.223 92.6538L149.691 48.2131L85.023 63.499L97.5551 107.94Z",
    fill: "#D0D2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5551 107.939L162.223 92.6535L148.713 49.1592L84.0453 64.4451L97.5551 107.939Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5549 107.94L162.223 92.6538L148.315 49.6523L83.647 64.9382L97.5549 107.94Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.294 59.4889C120.048 58.2633 120.761 57.1842 122.008 56.8893L141.513 52.2787C142.992 51.9291 144.711 52.7887 145.348 54.2022L162.381 91.8444C163.021 93.2549 162.337 94.6848 160.858 95.0344L98.966 109.664C97.487 110.014 95.7685 109.154 95.1308 107.741L81.0895 76.7136C80.4499 75.3031 81.1333 73.8732 82.6123 73.5236L116.291 65.5627C119.207 64.8708 120.866 62.3537 120.294 59.4889Z",
    fill: "#424B63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.732 50C185.732 50 187.353 73.032 207.851 83.6548C206.286 83.5292 204.4 105.088 204.777 106C204.023 104.838 194.594 108.989 178 83.3414C178 84.472 178.566 62.1053 185.732 50Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.936 66.8361C185.593 68.3639 185.991 69.9902 186.114 71.6485C186.206 72.8509 188.092 72.861 187.999 71.6485C187.848 69.6604 187.364 67.7119 186.566 65.8846C186.086 64.7735 184.461 65.7337 184.938 66.8361H184.936Z",
    fill: "#E3E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.119 71.575C185.669 70.9038 187 69.8128 187.964 68.4251C188.578 67.5611 187.153 66.7385 186.543 67.5954C185.718 68.735 184.591 69.6215 183.288 70.1551C182.317 70.5681 183.155 71.9854 184.118 71.5754L184.119 71.575Z",
    fill: "#E3E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.616 77.7399C184.334 78.1046 182.242 79.2314 180.683 80.9366C179.861 81.8278 181.191 83.1645 182.016 82.2702C183.353 80.805 185.155 79.8469 187.117 79.5582C188.312 79.3696 187.805 77.551 186.616 77.7399Z",
    fill: "#E3E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.135 77.9779C182.144 79.5912 182.873 81.3637 183.292 83.2202C183.561 84.4029 185.38 83.9025 185.11 82.719C184.651 80.704 183.858 78.7802 182.763 77.0274C182.122 75.9997 180.49 76.9456 181.135 77.9794V77.9779Z",
    fill: "#E3E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.881 86.7138C195.405 84.7847 188.535 74.3724 188.245 73.9285L188.875 73.5137C188.945 73.6197 195.896 84.1545 201.133 85.9973L200.881 86.7138Z",
    fill: "#E3E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.995 96.9327C193.52 95.004 186.649 84.5917 186.359 84.1474L186.99 83.7325C187.059 83.8385 194.01 94.3738 199.247 96.2161L198.995 96.9327Z",
    fill: "#E3E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.388 35.4431C177.071 35.4431 176 36.465 176 37.721C176 38.9769 177.071 39.9991 178.388 39.9991C179.705 39.9991 180.776 38.9772 180.776 37.721C180.776 36.4649 179.705 35.4431 178.388 35.4431ZM178.388 36.1584C179.291 36.1584 180.027 36.8597 180.027 37.7217C180.027 38.5839 179.291 39.2852 178.388 39.2852C177.485 39.2852 176.75 38.5837 176.75 37.7217C176.75 36.8597 177.485 36.1584 178.388 36.1584Z",
    fill: "#76A2F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.068 26C186.751 26 185.68 27.0218 185.68 28.2779C185.68 29.5337 186.751 30.5557 188.068 30.5557C189.384 30.5557 190.456 29.5341 190.456 28.2779C190.456 27.0218 189.384 26 188.068 26ZM188.068 26.7137C188.971 26.7137 189.706 27.4149 189.706 28.2771C189.706 29.1388 188.971 29.8402 188.068 29.8402C187.165 29.8402 186.429 29.1391 186.429 28.2771C186.429 27.4151 187.165 26.7137 188.068 26.7137Z",
    fill: "#E189A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.137 37.4306C198.142 37.2287 198.31 37.069 198.512 37.0739L200.164 37.0739C200.295 37.0677 200.42 37.1344 200.487 37.2475C200.555 37.3606 200.555 37.5017 200.487 37.6148C200.42 37.7279 200.295 37.7946 200.164 37.7884L198.512 37.7884C198.415 37.7907 198.321 37.7543 198.25 37.6872C198.18 37.6201 198.139 37.5278 198.137 37.4306Z",
    fill: "#80E5E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.247 37.4311C195.252 37.2293 195.419 37.0697 195.621 37.0744L197.273 37.0744C197.404 37.0682 197.529 37.1349 197.596 37.248C197.664 37.3611 197.664 37.5022 197.596 37.6153C197.529 37.7284 197.404 37.7951 197.273 37.7889L195.621 37.7889C195.524 37.7911 195.43 37.7547 195.36 37.6876C195.29 37.6205 195.249 37.5282 195.247 37.4311Z",
    fill: "#80E5E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.518 39.6422L197.518 38.2266C197.528 38.0269 197.693 37.8701 197.893 37.8701C198.092 37.8701 198.257 38.0269 198.267 38.2266L198.267 39.6422C198.257 39.8419 198.092 39.9987 197.893 39.9987C197.693 39.9987 197.528 39.8419 197.518 39.6422Z",
    fill: "#80E5E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.518 36.6345L197.518 35.219C197.528 35.0194 197.692 34.8625 197.892 34.8625C198.092 34.8625 198.257 35.0194 198.267 35.219L198.267 36.6345C198.257 36.8342 198.092 36.991 197.892 36.991C197.692 36.991 197.528 36.8342 197.518 36.6345Z",
    fill: "#80E5E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 180.5,
    y1: 32,
    x2: 128,
    y2: 116.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0252294,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities256A49B0);
export default __webpack_public_path__ + "static/media/activities.256a49b0.8236e33677ab2974bbfb366b565414a2.svg";
export { ForwardRef as ReactComponent };